// extracted by mini-css-extract-plugin
var _1 = "#000";
var _2 = "pfx-Typography-module__body--SsugD";
var _3 = "pfx-Typography-module__body-l--JW5Dx";
var _4 = "pfx-Typography-module__body-s--M_c2_";
var _5 = "pfx-Typography-module__body-xs--dPIQx";
var _6 = "1260px";
var _7 = "1020px";
var _8 = "668px";
var _9 = "1550px";
var _a = "1140px";
var _b = "940px";
var _c = "100%";
var _d = "15px";
var _e = "620px";
var _f = "#f53535";
var _10 = "rgba(0,0,0,.2)";
var _11 = "rgba(255,255,255,.38)";
var _12 = ".38";
var _13 = "pfx-Typography-module__display-block--Ls4ZC";
var _14 = "pfx-Typography-module__display-inline--T8tee";
var _15 = "rgba(255,255,255,.2)";
var _16 = "#0025ff";
var _17 = "pfx-Typography-module__glitch-anim--bZjhW";
var _18 = "pfx-Typography-module__glitch-anim-2--DyIEq";
var _19 = "#f60";
var _1a = "#41ead4";
var _1b = "#2cdd78";
var _1c = "#66ab23";
var _1d = "#f5f5f5";
var _1e = "#c3c3c3";
var _1f = "#ececec";
var _20 = "#252525";
var _21 = "#272727";
var _22 = "#c6c6c5";
var _23 = "#333";
var _24 = "#3c3c3c";
var _25 = "#9c9b9b";
var _26 = "#8c8c8c";
var _27 = "#6f6f6e";
var _28 = "#3c3c3b";
var _29 = "#373737";
var _2a = "#6a6a69";
var _2b = "#6f6f6f";
var _2c = "#9f9e9e";
var _2d = "#282828";
var _2e = "#828181";
var _2f = "#1d1d1d";
var _30 = "#979797";
var _31 = "#9c9b9b";
var _32 = "#a7a7a6";
var _33 = "#c6c6c5";
var _34 = "#d8d8d7";
var _35 = "#dddddc";
var _36 = "pfx-Typography-module__h1--nEvXR";
var _37 = "pfx-Typography-module__h2--szL5V";
var _38 = "pfx-Typography-module__h3--PGtKG";
var _39 = "pfx-Typography-module__h4--Bg2QI";
var _3a = "72px";
var _3b = "40px";
var _3c = "36px";
var _3d = "25px";
var _3e = "18px";
var _3f = "13px";
var _40 = "pfx-Typography-module__huge--qt7ki";
var _41 = "#0025ff";
var _42 = "rgba(255,255,255,.12)";
var _43 = "#6535f5";
var _44 = "2px";
var _45 = "56px";
var _46 = "56px";
var _47 = "pfx-Typography-module__mono--fGVUc";
var _48 = "pfx-Typography-module__mono-s--JPH1H";
var _49 = "#41ead4";
var _4a = "#f60";
var _4b = "#f83600";
var _4c = "#881f00";
var _4d = "18px";
var _4e = "15px";
var _4f = "red";
var _50 = "13px";
var _51 = "rgba(255,255,255,.07)";
var _52 = "#35465c";
var _53 = "#55acee";
var _54 = "pfx-Typography-module__typography--ttZV0";
var _55 = "#fff";
var _56 = "#ffce36";
var _57 = "#ffcd00";
var _58 = "red";
export { _1 as "black", _2 as "body", _3 as "bodyL", _4 as "bodyS", _5 as "bodyXs", _6 as "breakLarge", _7 as "breakMedium", _8 as "breakSmall", _9 as "breakVLarge", _a as "containerLarge", _b as "containerMedium", _c as "containerMobile", _d as "containerPaddingMobile", _e as "containerSmall", _f as "danger", _10 as "darkElement", _11 as "disabled", _12 as "disabledOpacity", _13 as "displayBlock", _14 as "displayInline", _15 as "extraLightElement", _16 as "facebook", _17 as "glitchAnim", _18 as "glitchAnim2", _19 as "google", _1a as "green", _1b as "green2", _1c as "greenColor", _1d as "grey1", _1e as "grey10", _1f as "grey2", _20 as "grey25", _21 as "grey27", _22 as "grey3", _23 as "grey33", _24 as "grey3C", _25 as "grey4", _26 as "grey41", _27 as "grey5", _28 as "grey6", _29 as "grey61", _2a as "grey6A", _2b as "grey6F", _2c as "grey7", _2d as "grey8", _2e as "grey82", _2f as "grey9", _30 as "grey97", _31 as "grey9C", _32 as "greyA7", _33 as "greyC6", _34 as "greyD8", _35 as "greyDd", _36 as "h1", _37 as "h2", _38 as "h3", _39 as "h4", _3a as "header1", _3b as "header2", _3c as "header3", _3d as "header4", _3e as "header5", _3f as "header6", _40 as "huge", _41 as "klein", _42 as "lightElement", _43 as "lilac", _44 as "menuBorder", _45 as "menuHeight", _46 as "menuMobileHeight", _47 as "mono", _48 as "monoS", _49 as "ocean", _4a as "orange", _4b as "orange2", _4c as "orangeDark", _4d as "paragraph", _4e as "paragraphSmall", _4f as "red", _50 as "subHeaderSmall", _51 as "subtleLightElement", _52 as "tumblr", _53 as "twitter", _54 as "typography", _55 as "white", _56 as "yellow", _57 as "yellowDeep", _58 as "youtube" }
